import UserAPI from '@/app/apis/main/user/user-api.js';

export default {
	/**
	 * @param {*} userEmail
	 */
	async getLoggedInUser(userEmail) {
		return UserAPI.getLoggedInUser(userEmail);
	},
	/**
	 * @param {*} userId, body
	 */
	async putUserDetails(userId, body) {
		return UserAPI.putUserDetails(userId, body);
	},
	/**
	* @param {*} userQuery
	*/
	async getUserList(userQuery) {
		return UserAPI.getUserList(userQuery);
	},
	/**
	* @param {*} userId
	* @param {*} statusDetails
	*/
	async putUserStatus(userId, statusDetails) {
		return UserAPI.putUserStatus(userId, statusDetails);
	},
	/**
	 * @param {*} userDetails
	 */
	async postUser(userDetails) {
		return UserAPI.postUser(userDetails);
	},
	/**
	* @param {*} userId
	*/
	async putTransferUser(userId) {
		return UserAPI.putTransferUser(userId);
	},
	/**
	* @param {*} userId
	*/
	async resendLink(emailAddress) {
		return UserAPI.resendLink(emailAddress);
	},
	/**
	* @param {*} userId
	* @param {*} statusDetails
	*/
	async putUserRole(userId, roleId) {
		return UserAPI.putUserRole(userId, roleId);
	},

	async getUserAddress() {
		return UserAPI.getUserAddress();
	},

	/**
	 * Fetches the default addresses for a user based on the address type.
	 * 
	 * @async
	 * @param {string} addressType - The type of address to fetch (e.g., 'home', 'work').
	 * @returns {Promise<Object[]>} A promise that resolves to an array of address objects.
	 */
	async getUserDefaultAddresses(addressType) {
		return UserAPI.getUserDefaultAddresses(addressType);
	},

	/**
	 * Deletes the default addresses for a user based on the provided details.
	 * 
	 * @async
	 * @param {Object} details - The details for deleting addresses.
	 * @param {string[]} details.addressIds - An array of address IDs to delete.
	 * @param {string} details.addressType - The type of addresses to delete.
	 * @returns {Promise<void>} A promise that resolves when the addresses have been deleted.
	 */
	async deleteUserDefaultAddresses(details) {
		return UserAPI.deleteUserDefaultAddresses(details);
	},

	/**
	* @param {*} userAddress
	*/
	async postUserAddress(userAddress) {
		return UserAPI.postUserAddress(userAddress);
	},

	/**
	* @param {referenceId}
	*/
	async postCreateUser(referenceId) {
		return UserAPI.postCreateUser(referenceId);
	},

		/**
	* @param {referenceId}
	*/
	async putDeactivateUser() {
		return UserAPI.putDeactivateUser();
	},
	/**
	 * 
	 * @param {email} userDetails 
	 */
	async postAuthForgotPass(userDetails) {
		return UserAPI.postAuthForgotPass(userDetails);
	}
}
